import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";

import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { useI18n } from "@/providers/i18n-provider";
import { Mailbox } from "@/features/mail/components/mailbox";
import { validateMailSearch } from "@/features/mail/route-search";

function MailPage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Your mail`)}
      description={t(msg`Sign in to connect a mailbox and read, send and search your email.`)}
    >
      <Mailbox />
    </AuthPlaceholder>
  );
}

export const mailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/mail",
  validateSearch: validateMailSearch,
  component: MailPage,
});
